import { BillingPlanTier } from '@recruitee/products-types';

export const ProductTierOrder = [
  BillingPlanTier.Launch,
  BillingPlanTier.Scale,
  BillingPlanTier.Lead,
  BillingPlanTier.Start,
  BillingPlanTier.Grow,
  BillingPlanTier.Optimize,
];

export type ComparableProduct = {
  codename: BillingPlanTier;
  slots?: number;
};

type CompareFn = (
  activeProduct: ComparableProduct,
  targetProduct: ComparableProduct,
) => boolean | null;

export const isDowngrade: CompareFn = (a, b) => {
  if (a.codename === b.codename && a.slots && b.slots) {
    if (a.slots === b.slots) {
      return null;
    }

    return a.slots > b.slots;
  } else {
    const aIndex = ProductTierOrder.indexOf(a.codename);
    const bIndex = ProductTierOrder.indexOf(b.codename);
    return aIndex > bIndex;
  }
};

export const isUpgrade: CompareFn = (a, b) => {
  const r = isDowngrade(a, b);
  return r === null ? r : !r;
};
